<template>
  <Stats :is_admin="is_admin"/>
</template>

<script>
import Stats from "@/view/pages/stats";

export default {
  data() {
    return {
      is_admin: true
    }
  },
  components: {
    Stats,
  },
};
</script>
